import {
  cleanDataByStoreKey,
  cleanLocationByIdState,
  cleanMessages,
  cleanSolrStateByType
} from './clean';
import {
  getCouponDetails
} from './content';
import {
  composeFiltersUiShape,
  saveFilteredArrays,
  setFiltersUiByKey,
  setNextFiltersUiByKey,
  toggleSegmentsUiByKey,
  setSortFilteredItemsByValue
} from './filters';
import tickets from './tickets/index';
import profile from './profile/index';
import reservations from './reservations/index';
import request from './request';
import carAndDriver from './carAndDriver';
import {setGmiState, deleteGmiState} from './map';
import {
  crossBrandDeepLink
} from './deepLinks';
import { loadGoogleMapsApi } from './googleMapsApi';
import { getAllHours } from './solr';
import recaptchaRequest from './recaptchaRequest';
import rentalTicket from './confirmModify/index';

/**
 * @namespace "actions"
 */
export default {
  cleanDataByStoreKey,
  cleanLocationByIdState,
  cleanMessages,
  cleanSolrStateByType,

  /**
   * @namespace "actions.content"
   */
  content: {
    getCouponDetails
  },

  crossBrandDeepLink,
  loadGoogleMapsApi,

  // namespace is set in actions/tickets/index.js
  tickets,

  /**
   * @namespace "actions.profile"
   */
  profile,

  // namespace is set in actions/reservations/index.js
  reservations,

  composeFiltersUiShape,
  saveFilteredArrays,
  setFiltersUiByKey,
  setNextFiltersUiByKey,
  toggleSegmentsUiByKey,
  setSortFilteredItemsByValue,

  request,
  recaptchaRequest,

  // namespace is set in actions/carAndDriver/index.js
  carAndDriver,

  setGmiState,
  deleteGmiState,

  /**
   * @namespace "actions.solr"
   */
  solr: {
    getAllHours
  },

  /**
   * @namespace "actions.rentalTicket"
   */
  rentalTicket
};
